export class Contact{
    Title: string;
    Prefix : string;
    FirstName : string;
    MiddleName : string;
    LastName : string;
    Suffix : string;
    Nickname : string;
    Designation : string;
    Address1 : string;
    Address2 : string;
    City : string;
    State : string;
    Zip : string;
    Country : string;
    WorkPhone : string;
    TollFree : string;
    Fax : string;
    Email : string;
    constructor() {
        this.Title = '';
        this.Prefix = '';
        this.FirstName = '';
        this.MiddleName = '';
        this.LastName = '';
        this.Suffix = '';
        this.Nickname = '';
        this.Designation = '';
        this.Address1 = '';
        this.Address2 = '';
        this.City = '';
        this.State = '';
        this.Zip = '';
        this.Country = '';
        this.WorkPhone = '';
        this.TollFree = '';
        this.Fax = '';
        this.Email = '';
        }
}